// Exporta o canvas do mapa como PNG sem biblioteca: clona o DOM, copia os
// estilos calculados de cada elemento, embute a letra do tema neon e desenha
// tudo num <canvas> via SVG <foreignObject>. PDF sai pela impressão do
// navegador (folha de estilo @media print do editor).

const XHTML = 'http://www.w3.org/1999/xhtml';

function copyComputedStyles(source, target) {
  const computed = window.getComputedStyle(source);
  let css = '';
  for (let i = 0; i < computed.length; i += 1) {
    const prop = computed[i];
    css += `${prop}:${computed.getPropertyValue(prop)};`;
  }
  target.setAttribute('style', css);
  const sourceChildren = source.children;
  const targetChildren = target.children;
  for (let i = 0; i < sourceChildren.length; i += 1) {
    if (targetChildren[i])
      copyComputedStyles(sourceChildren[i], targetChildren[i]);
  }
}

async function toDataUrl(url) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

// fonts: [{ family, weight, url }] — viram @font-face com data: URI, senão a
// imagem cai na letra padrão do sistema.
export async function fontFaceCss(fonts) {
  const faces = await Promise.all(
    fonts.map(async ({ family, weight, url }) => {
      const data = await toDataUrl(url);
      return `@font-face{font-family:'${family}';font-weight:${weight};src:url(${data}) format('woff2');}`;
    })
  );
  return faces.join('');
}

function loadImage(src) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

export async function elementToPngBlob(
  element,
  { background, fontCss = '', scale = 2 }
) {
  const { width, height } = element.getBoundingClientRect();
  const clone = element.cloneNode(true);
  copyComputedStyles(element, clone);
  const wrapper = document.createElementNS(XHTML, 'div');
  wrapper.setAttribute('style', `width:${width}px;height:${height}px;`);
  const style = document.createElementNS(XHTML, 'style');
  style.textContent = fontCss;
  wrapper.appendChild(style);
  wrapper.appendChild(clone);
  const html = new XMLSerializer().serializeToString(wrapper);
  const svg =
    `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">` +
    `<foreignObject x="0" y="0" width="100%" height="100%">${html}</foreignObject></svg>`;
  const image = await loadImage(
    `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`
  );

  const canvas = document.createElement('canvas');
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  const context = canvas.getContext('2d');
  context.scale(scale, scale);
  context.fillStyle = background;
  context.fillRect(0, 0, width, height);
  context.drawImage(image, 0, 0, width, height);
  return new Promise((resolve, reject) => {
    canvas.toBlob(
      blob => (blob ? resolve(blob) : reject(new Error('png vazio'))),
      'image/png'
    );
  });
}

export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

// Nome de arquivo seguro a partir do nome do mapa.
export function exportFileName(name, extension) {
  const base =
    String(name || 'mapa')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '') || 'mapa';
  return `${base}.${extension}`;
}
